<template>
    <base-activation-piece
        :deletable="deletable"
        :header-text="headerText"
        :icon="icon"
        :url="file.url"
        :thumbnail="file.url"
        :is-image="isImage"
        :file-name="fileName"
        :file-delete-name="file.name"
        :date="showDate ? file.updated_at : null"
        @file-deleted="handleFileDelete"
    />
</template>

<script>
    import { computed, toRefs } from 'vue-demi';
    import FILE_ICON_NAMES from '../../constants/file-icon-names';
    import FILE_DISPLAY_NAMES from '../../constants/file-display-names';
    import { IMAGE_MIME_TYPES } from '../../constants/file-mime-types';
    import BaseActivationPiece from './BaseActivationPiece.vue';

    export default {
        name: 'ActivationFile',
        components: {
            BaseActivationPiece
        },
        props: {
            file: {
                type: Object,
                required: true
            },
            deletable: {
                type: Boolean,
                default: false
            },
            showDate: {
                type: Boolean,
                default: true
            }
        },

        setup(props, { emit }) {
            const { file } = toRefs(props);

            const icon = computed(() => {
                if (FILE_ICON_NAMES.hasOwnProperty(file.value?.mime_type)) {
                    return FILE_ICON_NAMES[file.value?.mime_type];
                }

                return FILE_ICON_NAMES.default;
            });

            const headerText = computed(() => {
                if (FILE_DISPLAY_NAMES.hasOwnProperty(file.value?.mime_type)) {
                    return FILE_DISPLAY_NAMES[file.value?.mime_type];
                }

                return FILE_DISPLAY_NAMES.default;
            });

            const fileName = computed(() => {
                return file.value?.original_name ? file.value?.original_name : file.value?.name;
            });

            const isImage = computed(() => {
                return IMAGE_MIME_TYPES.includes(file.value?.mime_type);
            });

            const handleFileDelete = (fileName) => {
                emit('file-deleted', fileName);
            };

            return {
                icon,
                headerText,
                fileName,
                isImage,
                handleFileDelete
            };
        }
    };
</script>
